export default "__VITE_ASSET__C1wIPj_4__"